import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import VerticalDividedDialog from '@/templates/VerticalDividedDialog.vue';
import { reactive, computed, } from 'vue';
import { i18n } from '@/locales';
import { globalAlertType } from '@/constants/global';
import { alertActionType } from '@/vuex-store/alert/actions';
import { snackbarActionType } from '@/vuex-store/snackbar/actions';
import vuexStore from '@/vuex-store';
import SelectedWorkerListTable from './SelectedWorkerListTable.vue';
import InfoSettingSection from './InfoSettingSection.vue';
const lc = 'views.worker_management_bulk_edit.';
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        const createFormData = () => ({
            // 라이더 상태
            useYn: null,
            // 라이더 유형
            type: null,
            // 단말기 유형
            cardDeviceType: null,
            // 락타임
            orderDelayTimeSecond: null,
            // 접수 목록 제한
            acceptedOrderViewLimitCount: null,
            // GPS 활성화
            isForceGpsOn: null,
            // 공유배달 버튼
            isSharedOrderHidden: null,
            // 배차취소 권한
            isPossibleToCancelAllocatedOrder: null,
            // 픽업예상시간 수정 권한
            isImpossibleToChangePickupExpectedAt: null,
            // 도착지 주소 수정 권한
            isPossibleToChangeDropAddress: null,
            // 결제수단 변경 권한
            changePaymentAuthorityType: null,
            // 관제 권한
            isPossibleToControl: null,
            // 상점 송금 권한
            isPossibleToSendHubBaromoney: null,
            // 라이더 수수료 그룹
            workerDeliveryFeeGroupId: null,
            // 자동 차감 그룹
            workerCashAutoDeductGroupId: null,
        });
        // const formRef = ref<any>(null);
        const initFormData = createFormData();
        const formData = reactive(initFormData);
        const isWorkerBulkEditDialogOpen = computed(() => (vuexStore.state.workerManagement.workerBulkEdit.isWorkerBulkEditDialogOpen));
        function _setFormData(key, value) {
            formData[key] = value;
        }
        function convertSubmitDataToPayload(list) {
            return list.reduce((acc, [key, value,]) => {
                if (value === '') {
                    return acc;
                }
                acc[key] = value;
                return acc;
            }, {});
        }
        function _resetFormData() {
            Object.keys(formData).forEach((key) => {
                _setFormData(key, null);
            });
        }
        async function _onSubmit(submitData) {
            try {
                const submitDataList = Object.entries(submitData);
                const payload = convertSubmitDataToPayload(submitDataList);
                // console.log('submit formData', payload, JSON.stringify(payload));
                const response = await vuexStore.dispatch('workerManagement/workerBulkEdit/putWorkers', payload);
                if (!response.isSuccess) {
                    // res status 400
                    if (response.reason.length) {
                        // TODO 현재는 실패한 라이더 코드만 스낵바에 보여주도록 함, 기획 방향 잡히면 그에 맞게 추후 수정 필요
                        vuexStore.dispatch(snackbarActionType.showError, {
                            message: i18n.t(`${lc}edit_worker_info_fail`, {
                                workerNameList: response.reason.join(','),
                            }),
                        });
                        return;
                    }
                    // 네트워크, 서버 등 알 수 없는 에러의 경우
                    vuexStore.dispatch(snackbarActionType.showError, {
                        message: i18n.t('common.failure'),
                    });
                    return;
                }
                vuexStore.dispatch(snackbarActionType.showSuccess, {
                    message: i18n.t(`${lc}edit_worker_info_success`),
                });
                vuexStore.dispatch('workerManagement/workerBulkEdit/setWorkerBulkEditDialogOpen', false);
            }
            catch (error) {
                console.log('workerManagement/workerBulkEdit/putWorkers', error);
                vuexStore.dispatch(snackbarActionType.showError, {
                    message: i18n.t('common.failure'),
                });
            }
        }
        function handleSubmitForm() {
            // success
            return _onSubmit(formData);
        }
        function _closeDialog() {
            vuexStore.dispatch('workerManagement/workerBulkEdit/setWorkerBulkEditDialogOpen', false);
            _resetFormData();
        }
        function handleClickApplyDialogBtn() {
            handleSubmitForm();
        }
        async function handleClickCancelForm() {
            const isConfirmOk = await vuexStore.dispatch(alertActionType.confirm, {
                headerTitle: `${i18n.t(`${lc}title`)} ${i18n.t('common.cancel')}`,
                bodyContent: i18n.t('common.confirm_before_cancel'),
                alertType: globalAlertType.REMOVE,
            });
            if (isConfirmOk) {
                _closeDialog();
            }
        }
        function handleClickCancelDialogBtn() {
            handleClickCancelForm();
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(VerticalDividedDialog, {
                "is-open": isWorkerBulkEditDialogOpen.value,
                "on-apply": handleClickApplyDialogBtn,
                "on-cancel": handleClickCancelDialogBtn,
                "dialog-css-class": "width-md ratio-4-6"
            }, {
                title: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t(`${lc}title`)), 1 /* TEXT */)
                ]),
                leftSubTitle: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t(`${lc}left_sub_title`)), 1 /* TEXT */)
                ]),
                rightSubTitle: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t(`${lc}right_sub_title`)), 1 /* TEXT */)
                ]),
                leftContent: _withCtx(() => [
                    _createVNode(SelectedWorkerListTable)
                ]),
                rightContent: _withCtx(() => [
                    _createVNode(InfoSettingSection, {
                        "form-data": formData,
                        onSetFormData: _setFormData
                    }, null, 8 /* PROPS */, ["form-data"])
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["is-open"]));
        };
    }
});
